import * as React from 'react';
import { BodyText } from '../../../../components/ui/Typography';
import { useTranslation } from 'react-i18next';
import { SIDEBAR_OPTIONS } from './sidebarOptions';

interface SidebarProps {
  selectedKey: string | null;
  onSelect: (key: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ selectedKey, onSelect }) => {
  const { t } = useTranslation();
  return (
    <div
      className="flex bg-white h-full"
      style={{ borderRight: '1px solid rgba(0,0,0,0.15)' }}>
      <aside className="w-[85px] min-w-[85px] flex flex-col items-center pt-6 h-full">
        <nav className="flex flex-col gap-[4px]">
          {SIDEBAR_OPTIONS.map((opt) => {
            const IconComponent = opt.icon;
            const isSelected = selectedKey === opt.key;
            const color = isSelected ? '#3498DB' : 'rgba(0, 0, 0, 0.88)';

            return (
              <button
                key={opt.key}
                className="flex border-0 bg-white cursor-pointer flex-col items-center  transition-colors"
                onClick={() => onSelect(opt.key)}>
                <div style={{ color }}>
                  <IconComponent style={{ fontSize: 16, color }} />
                </div>
                <BodyText
                  className="text-[16px]"
                  style={{
                    color,
                    fontWeight: isSelected ? 'bold' : 'normal',
                    lineHeight: '23px',
                  }}>
                  {t(opt.label)}
                </BodyText>
              </button>
            );
          })}
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;
